/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FreshserviceTicketFilterElement {
    getFixupPrototypeFunction() { return FreshserviceTicketFilterElement.fixupPrototype; }

    static newInstance(model: Partial<FreshserviceTicketFilterElement>): FreshserviceTicketFilterElement {
        let obj = Object.assign(new FreshserviceTicketFilterElement(), model);
        FreshserviceTicketFilterElement.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FreshserviceTicketFilterElement>): FreshserviceTicketFilterElement {
        if (!model) return null;
        return FreshserviceTicketFilterElement.newInstance(<FreshserviceTicketFilterElement> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FreshserviceTicketFilterElement) {
        if (!obj) return;

        models.FreshserviceTicketFilterElement.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FreshserviceTicketFilterElement): boolean {
        Object.setPrototypeOf(obj, FreshserviceTicketFilterElement.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Id
     */
    id: string;

    /**
     * Name
     */
    name: string;

}
